import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../_service/message-service';
import { LoaderService } from 'src/app/loader.service';
import { TableColumn } from 'src/app/shared/interfaces/table-column';
import { AuthenticationService, UserService } from 'src/app/_services';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { ChargingProfileService } from '../create-charging-profile/charging-profile.service';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { Permission } from 'src/app/util/enums/permission.enum';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
declare var $: any;

export interface ChargingProfileData {
    id: number;
    chargingProfilePk: string;
    description: string;
    stackLevel: string;
    chargingProfilePurpose: string;
    chargingProfileKind: string;
    recurrencyKind: string;
    validFrom: string;
    validTo: string;
}

@Component({
    selector: 'telio-mobile-users',
    templateUrl: './charging-profiles.component.html',
    styleUrls: ['./charging-profiles.component.scss']
})
export class ChargingProfilesComponent implements OnInit {
    counter: number = 0;
    updateForm: UntypedFormGroup;
    description: any;
    deleteid: any;
    users: any = [];
    mobileusers: any = [];
    userroles: any = [];
    actionFeatureFlag = false;
    @ViewChild('swiper', { static: false }) swiper: ElementRef;
    useremail: string;
    mobileUserName;
    editAdjustment: UntypedFormGroup;
    walletAmount: number;
    walletDetails;
    formdetails;
    userDetails;
    input;
    loginemail;
    counterAmount: number;
    updatedAmount: number;
    columns: TableColumn[];
    chargingProfiles: ChargingProfileData[];
    tcolumns: TableColumn[];
    filterPlaceholder: string = '';
    actionFeatureLabel: string = '';
    initialData: any;
    chargingData: any;
    @ViewChild('viewProfile', { static: false }) viewProfile: TemplateRef<any>;

    pageList = {
        currentPage: 0,
        pageSize: 10
    };
    currentPage = 0;
    totalDataCount = 0;
    sortColumn = '';
    sortDirection = 'asc';

    constructor(private userService: UserService,
        private chargingProfileService: ChargingProfileService,
        private toastr: SnackbarService,
        private router: Router,
        readonly breadcrumbService: BreadcrumbService,
        private formBuilder: UntypedFormBuilder,
        private userInfoService: UserInfoService,
        public loaderService: LoaderService,
        readonly translate: TranslateService,
        readonly exportCSVService: ExportCSVService,
        private authenticationService: AuthenticationService,
        readonly route: ActivatedRoute,
        public dialog: MatDialog) {
        this.rerender(this.pageList, '');


        this.columns = [
            { columnDef: 'chargingProfilePk', header: 'ocpp.chargingProfile.id', cell: (element: ChargingProfileData) => `${element.chargingProfilePk}`, sortingDisabled: false, isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
            { columnDef: 'description', header: 'ocpp.chargingProfile.description', cell: (element: ChargingProfileData) => `${element.description}`, sortingDisabled: false },
            { columnDef: 'stackLevel', header: 'ocpp.chargingProfile.stackLevel', cell: (element: ChargingProfileData) => `${element.stackLevel}`, sortingDisabled: false },
            { columnDef: 'chargingProfilePurpose', header: 'ocpp.chargingProfile.purpose', cell: (element: ChargingProfileData) => `${element.chargingProfilePurpose}`, sortingDisabled: false },
            { columnDef: 'chargingProfileKind', header: 'ocpp.chargingProfile.profileKind', cell: (element: ChargingProfileData) => `${element.chargingProfileKind}`, sortingDisabled: false },
            { columnDef: 'recurrencyKind', header: 'ocpp.chargingProfile.recurrencyKind', cell: (element: ChargingProfileData) => `${element.recurrencyKind}`, sortingDisabled: false },
            { columnDef: 'validFrom', header: 'ocpp.chargingProfile.validFrom', cell: (element: ChargingProfileData) => `${element.validFrom}`, sortingDisabled: true },
            { columnDef: 'validTo', header: 'ocpp.chargingProfile.validTo', cell: (element: ChargingProfileData) => `${element.validTo}`, sortingDisabled: true }
        ];

        this.filterPlaceholder = 'generalTable.filterPlaceholder';
        this.actionFeatureLabel = 'ocpp.chargingProfile.createCharging';
    }

    ngOnInit(): void {
        this.updateForm = new UntypedFormGroup({
            description: new UntypedFormControl(),
            counter: new UntypedFormControl()
        })
        this.updateForm = this.formBuilder.group({
            description: ['', Validators.required],
            counter: ['', Validators.required]
        })
        this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
    }

    getmobileUsers(value: any, searchFilter: string = '') {
        this.chargingProfileService.getAllChargingProfiles(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter, this.userInfoService.userDetails.email).subscribe((resp: any) => {
            this.chargingProfiles = resp.body.data;
            this.totalDataCount = resp.body.totalItems;
            this.setChargingProfilesMap(this.chargingProfiles)
        }, err => {
            this.toastr.error(this.translate.instant('responseFailed'));
        });
    }

    dateTransform(date: string) {
        let dateIn: Date = new Date(date);
        let dateOut = dateIn.toISOString().split('T')[0];
        return dateOut;
    }

    actionClick() {
        this.rerender(this.pageList);
    }
    rerender(value: any, searchFilter?: string) {
        this.getmobileUsers(value, searchFilter)
    }
    actionCSV() {
        const options = {
            filename: this.translate.instant('ocpp.chargingProfile.title'),
            showTitle: false,
            title: this.translate.instant('ocpp.chargingProfile.title'),
            useKeysAsHeaders: true,
        }
        this.chargingProfileService.getAllChargingProfiles(1, this.totalDataCount, this.sortColumn, 'asc', '', this.userInfoService.userDetails.email).subscribe((resp: any) => {
            this.initialData = resp.body.data;
            this.setChargingProfilesMap(this.initialData)
            this.initialData.map(res => {
                res.id = '';
            })
            this.exportCSVService.exportCSV(options, this.initialData);
        });
    }

    actionFeature(e) {
        this.router.navigate(['/dashboard/charging-profiles/create', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
        this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGING_PROFILE_CREATE);
    }

    deleteUser(email, userId) {
        this.deleteid = userId;
        $("#deleteAlert").modal('show');
    }

    deleteuserbyemail() {
        this.userService.deleteUserById(this.deleteid).subscribe(
            (resp: any) => {
                if (resp != null) {
                    $("#deleteAlert").modal('hide');
                    this.toastr.success(resp.status_message);
                }
                else {
                    $("#deleteAlert").modal('hide');
                    this.toastr.error(resp.status_message);
                }
            },
            error => {
                this.toastr.error(error);
            }
        );
    }

    closedelete() {
        this.deleteid = {};
        $("#deleteAlert").modal('hide');
    }
    loadData(value: any) {
        let val = {
            currentPage: value.currentPage,
            pageSize: value.pageSize
        }
        this.pageList.pageSize = value.pageSize;
        this.rerender(val, '')
    }
    sortClick(event: any) {
        this.sortColumn = event.active;
        this.sortDirection = event.direction;
        this.rerender(this.pageList, '');
    }
    applyFilter(filteredData: string) {
        this.rerender(this.pageList, filteredData)
    }
    editWallet(item) {
        this.updateForm.reset()
        this.useremail = item.email;
        this.mobileUserName = item.username
        this.userService.getWalletAmount(item.email).subscribe(data => {
            this.walletDetails = data;
            this.walletAmount = +this.walletDetails.balance
        })
        $("#walletadjustment").modal('show');
    }
    closewallet(formData: any, formDirective: FormGroupDirective): void {
        formDirective.resetForm();
        this.updateForm.reset();
    }

    onDecrement() {
        this.counter -= 1;
        return this.counter;
    }

    onIncrement() {
        this.counter += 1;
        return this.counter;
    }

    updateWallet() {
        this.formdetails = this.updateForm.value;
        this.counterAmount = +this.formdetails.counter;
        this.updatedAmount = + (this.walletAmount + this.counterAmount)
        this.loginemail = this.authenticationService.getEmail()
        this.userDetails = this.userInfoService.userDetails;

        if (this.formdetails.counter === null) {
            this.toastr.error(this.translate.instant('chargingProfile.invalidAmountError'))
        }
        if (this.formdetails.description == null) {
            this.toastr.error(this.translate.instant('chargingProfile.descriptionMissing'))
            return
        }
        if (this.updatedAmount < 0) {
            this.toastr.error(this.translate.instant('chargingProfile.negativeAmountError'));
            return
        }
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const formData = new FormData();
        formData.append('userId', this.useremail);
        formData.append('amount', this.formdetails.counter);
        formData.append('description', this.formdetails.description)
        this.input = {
            'user_id': this.useremail,
            'amount': this.formdetails.counter,
            'description': this.formdetails.description
        }
        this.userService.updateWallet(this.input).subscribe(data => {
            if (data)
                this.toastr.success(this.translate.instant('transactions.walletUpdated'));
            $("#walletadjustment").modal('hide');
            this.router.navigate(['/dashboard/mobile-users', { routeID: MenuRouteID.MOBILE_USERS }]);
        },
            error => {
                this.toastr.error(this.translate.instant('transactions.enterValidAmount'))
            }
        )
    }

    linkClick(event) {
        if (event.column.columnDef == "chargingProfilePk") {
            this.chargingProfileService.getChargingProfileDetails(event.row.chargingProfilePk, this.userInfoService.userDetails.userId).subscribe(res => {
                if (!!res) {
                    this.chargingData = res;
                    let empty = 'NA';
                    // this.chargingData.validFrom = !!this.chargingData.validFrom ? this.authenticationService.convert24HrTo12Hr(this.chargingData.validFrom) : empty;
                    // this.chargingData.validTo = !!this.chargingData.validTo ? this.authenticationService.convert24HrTo12Hr(this.chargingData.validTo) : empty;
                    // this.chargingData.startSchedule = !!this.chargingData.startSchedule ? this.authenticationService.convert24HrTo12Hr(this.chargingData.startSchedule) : empty;
                    this.chargingData.validFrom = !!this.chargingData.validFrom ? this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.chargingData.validFrom, this.userInfoService.userDetails.prefCountry)) : empty;
                    this.chargingData.validTo = !!this.chargingData.validTo ?this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.chargingData.validTo, this.userInfoService.userDetails.prefCountry)) : empty;
                    this.chargingData.startSchedule = !!this.chargingData.startSchedule ? this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(this.chargingData.startSchedule, this.userInfoService.userDetails.prefCountry)) : empty;
                    let dialogRef = this.dialog.open(this.viewProfile, {
                        height: '550px',
                        width: '800px'
                    }).afterClosed().subscribe((res: any) => {
                    })
                } else {
                    this.toastr.error(this.translate.instant('generalTable.noRecord'));
                }
            }, error => {
                this.toastr.error(this.translate.instant('generalTable.noRecord'));
            })
        }
    }

    checkPermission(id: number, permission: string): boolean {
        return this.userInfoService.filterPermission(id, permission)
    }

    setChargingProfilesMap(data) {
        data.map((item: any, i: number) => {
            let empty = 'NA';
            item.id = i;
            item.chargingProfilePk = !item.chargingProfilePk ? empty : item.chargingProfilePk;
            item.description = !item.description ? empty : item.description;
            item.stackLevel = !item.stackLevel ? empty : item.stackLevel;
            item.chargingProfilePurpose = !item.chargingProfilePurpose ? empty : item.chargingProfilePurpose;
            item.chargingProfileKind = !item.chargingProfileKind ? empty : item.chargingProfileKind;
            item.recurrencyKind = !item.recurrencyKind ? empty : item.recurrencyKind;
            item.validFrom = !item.validFrom ? empty :
                this.authenticationService.convertToLocalTime(item.validFrom, this.userInfoService.userDetails.prefCountry).split(' ')[0];
            item.validTo = !item.validTo ? empty :
                this.authenticationService.convertToLocalTime(item.validTo, this.userInfoService.userDetails.prefCountry).split(' ')[0];
        });
    }
}
